import { MeetingModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class MeetingService extends BaseService<MeetingModel> {}

export default new MeetingService('meetings');
